import { createStore } from 'vuex';

export default createStore({
	state: {
		languageLoad: false,
		userInfo: '',
		user: {
			name: '',
			avatar: ''
		},
		memberInfo: {
			expire_time: '',
			member_num: '',
			user_id: '',
			is_member: false,
			use_space: 0,
			available_space: 0,
			is_pr_ws: 0,
		},
		keepAlive: false,
		firstOpen: true,
		unit: 'mm',
		isGuest: false, //是否游客
		online: true, // 是否有网环境
		inElectron: false //是否是Electron应用内
	},
	mutations: {
		setUserInfo(state, userInfo) {
			state.userInfo = userInfo;
			state.isGuest = userInfo ? false : true; // 如果用户为空，则为游客
		},
		setOnline(state, online) {
			state.online = online;
		},
		setElectron(state, inElectron) {
			state.inElectron = inElectron;
		},
		setMemberInfo(state, memberInfo) {
			state.memberInfo = memberInfo;
		},
		setKeepAlive(state, keepAlive) {
			state.keepAlive = keepAlive;
		},
		setUnit(state, unit) {
			state.unit = unit;
		},
		setGuest(state, isGuest) {
			state.isGuest = isGuest;
		}
	},
	actions: {
		//存在对Electron应用的特殊处理
		setInternet({ commit }, online) {
			commit('setOnline', online);
		},
		setGuest({ commit }) {
			commit('setUserInfo', null);
		},
		setinElectron({ commit }, inElectron) {
			commit('setElectron', inElectron);
		}
	},
	modules: {},
	getters: {
		getLanguageLoad(state) {
			return state.languageLoad;
		},
		getUserInfo(state) {
			return state.userInfo;
		},
		getMemberInfo(state) {
			return state.memberInfo;
		},
		getFirstOpen(state) {
			return state.firstOpen;
		},
		getKeepAlive(state) {
			return state.keepAlive;
		},
		getUnit(state) {
			return state.unit;
		},
		getIsGuest(state) {
			return state.isGuest;
		}
	}
});
